
import React, {Component} from 'react';
import { Pagination, Tabs, Tab, HelpBlock, DropdownButton, MenuItem, Button, Form, FormControl, FormGroup, InputGroup, ControlLabel, Row, Col, Popover, Tooltip, OverlayTrigger, Modal } from 'react-bootstrap';
import { Box } from 'reactjs-admin-lte';
import Select from 'react-select';
import FontAwesome from 'react-fontawesome';
import { Checkbox, Radio } from 'react-icheck';
import Moment from 'moment';
import ReportStore from '../../stores/ReportStore';
import IframeModal from '../../component/element/IframeModal'
import Chart from 'chart.js';
import { findDOMNode } from 'react-dom'

import './report.css'
var MobileDetect = require('mobile-detect')
class ReportPOAndExpense extends Component {

  constructor(...args){
    super(...args)

    const yTh = parseInt(Moment().format('YYYY')) + 543
    const curMonth = parseInt(Moment().format('MM'))
    const curDay = parseInt(Moment().format('DD'))
    
    if (this.props.typePrint==='chart') {
      var all_day = Moment(this.props.year-543+'-'+this.props.month, "YYYY-MM").daysInMonth()
    } else {
      var all_day = Moment().daysInMonth()
    }

    const optionsDay = []
    const optionsYear = []

    for (var i = yTh; i >= 2557; i--) {
      optionsYear.push({
        value: i,
        label: i
      });
    }

    for (var i=0;i<=all_day;i++) {
      if (i == 0) {
        var label = 'ทั้งเดือน'
      } else {
        var label = i
      }
      optionsDay.push({
        value: i,
        label: label
      })
    }

    const optionsMonth = [
      { value: 0, label: 'ทั้งปี' },
      { value: 1, label: 'มกราคม' },
      { value: 2, label: 'กุมภาพันธ์' },
      { value: 3, label: 'มีนาคม' },
      { value: 4, label: 'เมษายน' },
      { value: 5, label: 'พฤษภาคม' },
      { value: 6, label: 'มิถุนายน' },
      { value: 7, label: 'กรกฎาคม' },
      { value: 8, label: 'สิงหาคม' },
      { value: 9, label: 'กันยายน' },
      { value: 10, label: 'ตุลาคม' },
      { value: 11, label: 'พฤศจิกายน' },
      { value: 12, label: 'ธันวาคม' }
    ];

    const optionsRows = [10,20,50,100]; 

    if (this.props.showPrintPreview != true) {
        var defaultMonth = curMonth
        var defaultYear = yTh
        var defaultDay = 0
    } else { 
        var defaultMonth = this.props.month
        var defaultYear = this.props.year
        var defaultDay = this.props.day
    }

    let md = new MobileDetect(window.navigator.userAgent);
    if(md.is('iOS') || md.is("AndroidOS")){ 
      var sliptable_page = "sliptable-page iv-olview"
      var title_desktop = ""
    } else { 
      var sliptable_page = "sliptable-page-desktop iv-olview"
      var title_desktop = "title-desktop"
    }

    this.state = {
      title_desktop:title_desktop,
      sliptable_page:sliptable_page,
      check_date:[],
      dataFormat:[],
      optionsYear: optionsYear, 
      optionsMonth: optionsMonth,
      optionsDay: optionsDay,
      defaultMonth: defaultMonth,
      defaultYear: defaultYear,
      defaultDay: defaultDay,
      all_page:[],
      all_row:[],
      use_row:0,
      set_use_row:0,
      check_render:[{
        new_page: "", 
        key: "undefined"
      }],
      excess:[{
        index:"undefined"
      }],
      check_row:0,
      sub_call: "",
      index_dup: "",
      data: [],
      // check_render_title: [],
      displayTb:"",
      displayBar:"none",
      btnBar:(<div><FontAwesome name='bar-chart'/>&nbsp;ดูกราฟแท่ง</div>),
      btnAction:"barchart",
      loading: false,  
      // length: 10,
      totalPage: 0,
      activePage: 1,
      report_title: 'กำลังดึงข้อมูล..',
      defaultRows: 10,
      optionsRows: optionsRows
    }
    this.barChart = null
  }

  componentWillReceiveProps(newProps){
    if(newProps.show && newProps.show!==this.props.show){
      this.loadPoAndExpense(this.state.defaultYear-543, this.state.defaultMonth, this.state.defaultDay)
    }
  }

  getAllDayOfMonth(date) {
    const all_day = Moment(date, "YYYY-MM").daysInMonth()
    const optionsDay = []

    if (all_day) {
      for (var i=0;i<=all_day;i++) {
        if (i == 0) {
          var label = 'ทั้งเดือน'
        } else {
          var label = i
        }
        optionsDay.push({
          value: i,
          label: label
        })
      }
      if (all_day<this.state.defaultDay) {
        var defaultDay = 0
      } else {
        var defaultDay = this.state.defaultDay
      }
    } else {
      optionsDay.push({
        value: 0,
        label: 'ทั้งเดือน'
      })
      var defaultDay = 0
    }

    this.setState({ optionsDay: optionsDay, defaultDay:defaultDay })
    return defaultDay
  }

  handleSelect(e) {
    this.setState({ activePage: e })
    this.loadPoAndExpense(this.state.defaultYear - 543, this.state.defaultMonth, this.state.defaultDay, e, '', this.state.defaultRows)
  }

  onYearChange(e) {
    var year = e.value - 543

    var date = year+"-"+this.state.defaultMonth
    let curDay = 0
    curDay = this.getAllDayOfMonth(date)

    this.setState({ defaultYear: e.value, activePage:1, defaultDay:curDay })
    this.loadPoAndExpense(year, this.state.defaultMonth, curDay, 1, '', this.state.defaultRows)
  }

  onMonthChange(e) {
    var date = this.state.defaultYear - 543+"-"+e.value
    let curDay = 0
    curDay = this.getAllDayOfMonth(date)

    this.setState({ defaultMonth: e.value, activePage:1, defaultDay:curDay })
    this.loadPoAndExpense(this.state.defaultYear - 543, e.value, curDay, 1, '', this.state.defaultRows)
  }

  onDayChange(e) {
    this.setState({ defaultDay: e.value })
    this.loadPoAndExpense(this.state.defaultYear - 543, this.state.defaultMonth, e.value, 1, '', this.state.defaultRows)
  }

  onRowsPerPageChange(e) {
    let rows = e
    var date = this.state.defaultYear - 543+"-"+this.state.defaultMonth
    let curDay = 0
    curDay = this.getAllDayOfMonth(date)

    this.setState({ defaultRows: rows, activePage:1, defaultDay:curDay })
    this.loadPoAndExpense(this.state.defaultYear - 543, this.state.defaultMonth, curDay, 1, '', rows)
  }

  onPrintClick(){
    let type_print = 'report'
    if (this.state.displayBar==='')
      type_print = 'chart'

    var year = this.state.defaultYear - 543
    let url = ''
    if (process.env.NODE_ENV == "development") {
      url  = './?startPage=PrintReportPOAndExpense&year='+year+"&month="+this.state.defaultMonth+"&day="+this.state.defaultDay+"&type_print="+type_print
    } else{
      url = './pdf/v2/?startPage=PrintReportPOAndExpense&year='+year+"&month="+this.state.defaultMonth+"&day="+this.state.defaultDay+"&type_print="+type_print
    }
    this.refs.iframe.loadUrl(url)
  }

  loadPoAndExpense(year='', month='', day='', page = 1, lengthData='', rowsData=10) {
    let _length = rowsData
    if (lengthData=='all'||this.props.lengthData=='all') {
      _length = ''
    }

    if (year=='') {
      year = this.state.defaultYear - 543
    }
    if (month==''&&month!='0') {
      month = this.state.defaultMonth
    }
    if (day=='') {
      day = this.state.defaultDay
    }

    let that = this
    //that.setState({loading:true,defaultRows:rowsData})
    let {check_date} = this.state
    let {dataFormat} = this.state
    var doc_no = []
    var supplier_name = []
    var amount = []
    var sum_amount = 0

    if (page == 1) {
      var start = 0
      //that.setState({ activePage: page })
    } else {
      var start = (page * rowsData) - rowsData
    }

    ReportStore.loadReportPoAndExpense(year, month, day, start, _length, function(result) {
      that.setState({loading:true,defaultRows:rowsData})
      if (page == 1) {
        that.setState({ activePage: page })
      }   

      const totalPage = result.data_count / rowsData
      that.setState({data:[], dataFormat:[], check_date:[]})

      for (var i=0;i<result.data.length;i++) {
        if (check_date.indexOf(result.data[i].doc_date)==-1) {
          check_date.push(result.data[i].doc_date)
        }
      }

      for (var i=0;i<check_date.length;i++) {
        for (var j=0;j<result.data.length;j++) {
          if (check_date[i]==result.data[j].doc_date) {
            doc_no.push(result.data[j].doc_no)
            supplier_name.push(result.data[j].supplier_name)
            amount.push(result.data[j].amount)
            sum_amount = parseInt(sum_amount) + parseInt(result.data[j].amount)
          }
        }
        dataFormat.push({
          doc_date: check_date[i],
          meta: {
            doc_no: doc_no,
            supplier_name: supplier_name,
            amount: amount
          },
          sum_amount: sum_amount
        })
        doc_no = []
        supplier_name = []
        amount = []
        sum_amount = 0
      }

      that.setState({data:dataFormat, dataFormat:[],totalPage: Math.ceil(totalPage), loading:false, report_title:'ไม่พบข้อมูล'})
      if (that.props.typePrint==='chart') {
        that.setBarChart()
      }
    })  
  }  

  setBarChart() { 
    this.canvasBar = findDOMNode(this.canvasBarRef);
    this.ctxBar = this.canvasBar.getContext('2d');
    let canvasBar = this.canvasBar,ctxBar=this.ctxBar
    let {data,defaultMonth,optionsDay} = this.state
    let labels = []
    let data_barchart = []
    let data_year = [0,0,0,0,0,0,0,0,0,0,0,0]
    let data_month = []
    if (defaultMonth=="0") {
      let i = 0
      let January = 'มกราคม'
      let February = 'กุมภาพันธ์'
      let March = 'มีนาคม'
      let April = 'เมษายน'
      let May = 'พฤษภาคม'
      let June = 'มิถุนายน'
      let July = 'กรกฎาคม'
      let August = 'สิงหาคม'
      let September = 'กันยายน'
      let October = 'ตุลาคม'
      let November = 'พฤศจิกายน'
      let December = 'ธันวาคม'
      labels = [January,February,March,April,May,June,July,August,September,October,November,December]
      data.forEach(element => {
        let month = ""
        month = element.doc_date.substring(5, 7)
        month = parseInt(month) - 1
        data_year[month] = parseFloat(data_year[month]) + parseFloat(element.sum_amount)
        i++
      })
      data_barchart = data_year
    } else {
      for(var i=0;i<optionsDay.length-1;i++) {
        data_month[i] = 0
        labels[i] = i+1
      }
      let i = 0
      data.forEach(element => {
        let day = ""
        day = element.doc_date.substring(8, 10)
        day = parseInt(day) - 1
        data_month[day] = parseFloat(data_month[day]) + parseFloat(element.sum_amount)
        i++
      })
      data_barchart = data_month
    }
    if(this.barChart!=null){
      this.barChart.destroy();
    }
    this.barChart = new Chart(ctxBar, {
      type: 'bar',
      data: {
          labels: labels,
          datasets: [{
              label: 'รายจ่าย',
              data: data_barchart,
              backgroundColor: '#d2d6de'
          }]
      },
      options: {
          scales: {
              yAxes: [{
                  ticks: {
                      beginAtZero:true
                  }
              }]
          }
      }
    });
  }

  onBarChartClick(action,e) {
    let {displayTb,displayBar,btnBar,btnAction,defaultYear,defaultMonth,defaultDay} = this.state
    let new_action = ""
    if (action=="barchart") {
      new_action = "report"
      this.setState({btnAction:new_action,displayTb:'none',displayBar:'',btnBar:(<div><FontAwesome name='file-text'/>&nbsp;ดูรายงาน</div>)})
      this.loadPoAndExpense(defaultYear-543, defaultMonth, defaultDay, 1, 'all', this.state.defaultRows)
      this.setBarChart()  
    } else {
      new_action = "barchart"
      this.setState({btnAction:new_action,displayTb:'',displayBar:'none',btnBar:(<div><FontAwesome name='bar-chart'/>&nbsp;ดูกราฟแท่ง</div>)})
      this.loadPoAndExpense(defaultYear-543, defaultMonth, defaultDay, 1, '', this.state.defaultRows)
    }
  }

  renderTable() {
    return(
      <div className="display-overflow">
        <table className="table table-responsive table-bordered-solid table-hover table-report-po">
          <thead>
            <tr>
              <th style={{width:"90px"}}>เลขที่เอกสาร</th>
              <th style={{width:"300px"}}>ชื่อผู้ขาย</th>
              <th style={{width:"90px"}}></th>
              <th style={{width:"90px"}} className="text-right">มูลค่ารวม</th>
              <th style={{width:"90px"}} className="text-right">ภาษี</th>
              <th style={{width:"90px"}} className="text-right">รวมทั้งสิ้น</th>
            </tr>
          </thead>
          <tbody>
            {this.renderRowData()}
          </tbody>
        </table>
      </div>
    )
  }

  renderRowData() {
    var sum_all_day = 0
    if (this.state.data.length>0) {
      return(
        this.state.data.map((item, index) => {
          sum_all_day = parseInt(sum_all_day) + parseInt(item.sum_amount)
          var check_last = "none" 
          if (index==this.state.data.length-1) {
            check_last = ""
          }

          return(
            <tr key={index}>
              <td>
                <div className="bd-date">{item.doc_date}</div>
                {
                  item.meta.doc_no.map((doc_no, index) => {
                    return(
                      <div key={index}>
                        {doc_no}
                      </div>
                    )
                  })  
                }
              </td>
              <td>
                <div className="bd-date"><br/></div>
                {
                  item.meta.supplier_name.map((supplier_name, index) => {
                    return(
                      <div key={index}>
                        {supplier_name}
                      </div>
                    )
                  })  
                }
              </td>
              <td>
                <div className="bd-date"><br/></div>
                {
                  item.meta.supplier_name.map((supplier_name, index) => {
                    if (index==item.meta.supplier_name.length-1) {
                      var bd_sum = "bd-sum"
                    } else {
                      var bd_sum = ""
                    }
                    return(
                      <div key={index} className={bd_sum}>
                        <br/>
                      </div>
                    )
                  })  
                }
                <div className="bd-sum text-left"><b>รวม/วัน</b></div>
                <div style={{display:check_last}} className="bd-sum text-left"><b>ยอดรวมสุทธิ</b></div>
              </td>
              <td className="text-right">
                <div className="bd-date"><br/></div>
                {
                  item.meta.amount.map((amount, index) => {
                    if (index==item.meta.amount.length-1) {
                      var bd_sum = "bd-sum"
                    } else {
                      var bd_sum = ""
                    }
                    return(
                      <div key={index} className={bd_sum}>
                        {amount}
                      </div>
                    )
                  })  
                }
                <div className="bd-sum">{item.sum_amount.toLocaleString(undefined, {minimumFractionDigits: 2})}</div> 
                <div style={{display:check_last}} className="bd-sum"><br/></div>
              </td>
              <td className="text-right">
                <div className="bd-date"><br/></div>
                {
                  item.meta.amount.map((amount, index) => {
                    if (index==item.meta.amount.length-1) {
                      var bd_sum = "bd-sum"
                    } else {
                      var bd_sum = ""
                    }
                    return(
                      <div key={index} className={bd_sum}>
                        0.00
                      </div>
                    )
                  })  
                }
                <div className="bd-sum">0.00</div>  
                <div style={{display:check_last}} className="bd-sum"><br/></div>
              </td>
              <td className="text-right">
                <div className="bd-date"><br/></div>
                {
                  item.meta.amount.map((amount, index) => {
                    if (index==item.meta.amount.length-1) {
                      var bd_sum = "bd-sum"
                    } else {
                      var bd_sum = ""
                    }
                    return(
                      <div key={index} className={bd_sum}>
                        {amount}
                      </div>
                    )
                  })  
                }
                <div className="bd-sum">{item.sum_amount.toLocaleString(undefined, {minimumFractionDigits: 2})}</div> 
                <div style={{display:check_last}} className="bd-sum"><b>{sum_all_day.toLocaleString(undefined, {minimumFractionDigits: 2})}</b></div>
              </td>
            </tr>
          )  
        })
      )
    } else {
      return(<tr><td colSpan={6}>ไม่พบข้อมูล</td></tr>)
    }  
  }

  renderBarChat() {
    return(
      <div>
        <canvas 
          ref={(canvasBar) => { this.canvasBarRef = canvasBar; }}>
        </canvas>
      </div>
    )
  }

  render(){
      return (
        <div>  
          <Box loading={this.state.loading}>
            <Box.Header border={true}>
              <Box.Title>
                {this.props.renderMenu()}
              </Box.Title>
              <Box.Tools >
                <Button                 
                bsStyle={'link'} className='bg-maroon'
                onClick={this.onPrintClick.bind(this)}
                >
                    <FontAwesome name='print'/>&nbsp;พิมพ์เอกสาร
                </Button> 
                                      
              </Box.Tools>
            </Box.Header>
            <Box.Body>
              <Form inline>
                <FormGroup>
                  <Select
                    clearable={false}
                    name="form-field-name"
                    value={ this.state.defaultYear }
                    options={this.state.optionsYear}
                    style={{ width: "150px" }}
                    onChange={ this.onYearChange.bind(this) }
                  />
                </FormGroup>  
                {' '}
                <FormGroup>
                  <Select
                    clearable={false}
                    name="form-field-name"
                    value={ this.state.defaultMonth }
                    options={this.state.optionsMonth}
                    style={{ width: "180px" }}
                    onChange={ this.onMonthChange.bind(this) }
                />
                </FormGroup>  
                {' '}
                <FormGroup>
                  <Select
                    clearable={false}
                    name="form-field-name"
                    value={ this.state.defaultDay }
                    style={{ width: "110px" }}
                    options={this.state.optionsDay}
                    onChange={this.onDayChange.bind(this)}
                  />
                </FormGroup>
                {' '}
                <FormGroup>
                  <Button
                  className='btn-primary'
                  onClick={this.onBarChartClick.bind(this,this.state.btnAction)}
                  >
                    {this.state.btnBar}
                  </Button>
                </FormGroup>
              </Form> 
              <br/>
              <div style={{display:this.state.displayTb}}>
                {this.renderTable()}
                <div className="text-right">
                  <Form inline>
                    <FormGroup>
                      จำนวนแถวต่อหน้า
                    </FormGroup>  
                    {' '}
                    <FormGroup>
                      <DropdownButton id='select-page' bsStyle={'default'} title={this.state.defaultRows} onSelect={this.onRowsPerPageChange.bind(this)}>
                        {this.state.optionsRows.map((item,index)=>(
                          <MenuItem key={index} eventKey={item}>{item}</MenuItem>  
                        ))}
                      </DropdownButton>
                    </FormGroup> 
                    {' '} 
                    <FormGroup style={{lineHeight:'10px'}}>
                      <Pagination
                        prev={'ก่อนหน้า'}
                        next={'ถัดไป'}
                        first={false}
                        last={false}
                        ellipsis
                        boundaryLinks
                        items={this.state.totalPage}
                        maxButtons={5}
                        activePage={this.state.activePage}
                        onSelect={this.handleSelect.bind(this)}
                      />
                    </FormGroup>  
                  </Form>  
                </div>
              </div> 
              <div style={{display:this.state.displayBar}}>
                {this.renderBarChat()}
              </div>
              <IframeModal ref='iframe' title={'พิมพ์เอกสาร'} />
            </Box.Body>
          </Box>
        </div>
      )
  } 
}

ReportPOAndExpense.defaultProps = {
  show : false
}

export default ReportPOAndExpense;


// WEBPACK FOOTER //
// ./src/view/report/ReportPOAndExpense.js